//Live url

const FileUpload = 'https://hrmsdbdemobk.keelis.in/media/'

export default FileUpload;
